import { render, staticRenderFns } from "./purchasePlanOrderDetails.vue?vue&type=template&id=66c50fb5&scoped=true&"
import script from "./purchasePlanOrderDetails.vue?vue&type=script&lang=js&"
export * from "./purchasePlanOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c50fb5",
  null
  
)

component.options.__file = "purchasePlanOrderDetails.vue"
export default component.exports